import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, viewChild, ViewEncapsulation} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {NavigationEnd, Router} from '@angular/router';
import {filter, Observable} from 'rxjs';

import {FuseConfigService} from '@fuse/services/config.service';
import {navigation} from 'app/navigation/navigation';
import {ComponentCleaner} from 'app/kluh-manager/component-cleaner';

@Component({
    selector: 'vertical-layout-1',
    templateUrl: './layout-1.component.html',
    styleUrls: ['./layout-1.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VerticalLayout1Component extends ComponentCleaner implements AfterViewInit
{
    readonly fuseConfig = toSignal(this._fuseConfigService.config as Observable<any>, {initialValue: {} as any});
    navigation: any;
    readonly scrollContainer = viewChild<ElementRef>('container3');

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _router: Router,
    )
    {
        super();
        this.navigation = navigation;
    }

    ngAfterViewInit(): void {
        this.addSubscription(
            this._router.events.pipe(
                filter(event => event instanceof NavigationEnd)
            ).subscribe(() => {
                const container = this.scrollContainer();
                if (container) {
                    container.nativeElement.scrollTop = 0;
                }
            })
        );
    }
}
